import { PriceScaleMode } from 'lightweight-charts'
import { isNumber } from 'lodash'
import moment from 'moment-timezone'

export default (that, data, timeZone, ticker, color) => {
  if (that.chartType == 'candles') {
    that.candleSeries = that.chart.addCandlestickSeries({
      priceFormat: {
        type: 'custom',
        minMove: 0.02,
        formatter: (price) => {
          return isNumber(price)
            ? price.toFixed(that.$store.state.market.digitsAfterDot)
            : price.toString()
        },
      },
    })
    const dataSorted = data
      .map((el) => ({
        ...el,
        time: Math.trunc(moment(el.time).valueOf() / 1000 + timeZone),
      }))
      .sort((a, b) => a.time - b.time)
    that.candleSeries.setData(dataSorted)
    that.candleSeries._myData = dataSorted
    that.currentBar = dataSorted[dataSorted.length - 1]
    that.candleSeries.applyOptions({
      priceFormat: {
        type: 'custom',
        minMove: 0.02,
        formatter: (price) => {
          return isNumber(price)
            ? price.toFixed(that.$store.state.market.digitsAfterDot)
            : price.toString()
        },
      },
    })
    that.loadedUntil = dataSorted[0].time
  } else {
    // line
    if (!that.lineSeries) that.lineSeries = {}
    that.lineSeries[ticker] = that.chart.addLineSeries({
      color: color || '#007AFF',
    })
    const dataSorted = data
      .map((el) => ({
        value: el.close,
        time: Math.trunc(moment(el.time).valueOf() / 1000),
      }))
      .sort((a, b) => a.time - b.time)
    that.lineSeries[ticker].setData(dataSorted)
    that.lineSeries[ticker]._myData = dataSorted
    that.currentBar.open = null
  }

  if (that.chart) {
    that.chart.timeScale().resetTimeScale()
    that.chart.priceScale('right').applyOptions({
      autoscale: true,
      mode:
        that.lineSeries && Object.entries(that.lineSeries).length > 1
          ? PriceScaleMode.Percentage
          : PriceScaleMode.Normal,
    })
  }
}
